import axios from 'axios';
import { client } from 'laravel-precognition';
import { axiosAdapter } from 'laravel-precognition/axios';

export function setupPrecognition(): void {
    // Keep validation requests separate from the global response/toast interceptors.
    const validationAxios = axios.create({
        withXSRFToken: true,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    client.useHttpClient(axiosAdapter(validationAxios)).withCredentials(true);
}
